import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';

@Injectable()
export class NotificationQueueHttpService {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Call API to dismiss notification
   * @param notificationId - notification's id to dismiss
   */
  dismissNotification(notificationId: string): Observable<string> {
    return this.httpClient.get<string>(`${environment.apiHost}/NotificationDashboard/DismissNotification/${notificationId}`);
  }

  /**
   * Call API to snooze notification
   * @param notificationId - notification's id to dismiss
   * @param minutes - minutes to snooze
   */
  snoozeNotification(notificationId: string, minutes: number): Observable<string> {
    return this.httpClient.get<string>(`${environment.apiHost}/NotificationDashboard/SnoozeNotification/${notificationId}/${minutes}`);
  }
}
